import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';

interface InactivityWarningDialogProps {
  open: boolean;
  remainingMs: number;
  onStayLoggedIn: () => void;
}

const InactivityWarningDialog: React.FC<InactivityWarningDialogProps> = ({ open, remainingMs, onStayLoggedIn }) => {
  const [secondsLeft, setSecondsLeft] = useState(Math.ceil(remainingMs / 1000));
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (open) {
      setSecondsLeft(Math.ceil(remainingMs / 1000));
      intervalRef.current = setInterval(() => {
        setSecondsLeft(prev => {
          if (prev <= 1) {
            if (intervalRef.current) clearInterval(intervalRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [open, remainingMs]);

  const formatTime = useCallback((totalSeconds: number) => {
    const m = Math.floor(totalSeconds / 60);
    const s = totalSeconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  }, []);

  return (
    <Dialog open={open} disableEscapeKeyDown aria-labelledby="inactivity-warning-title">
      <DialogTitle id="inactivity-warning-title" sx={{ color: '#b71c1c' }}>
        Økt utløper snart
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Du har vært inaktiv for lenge. Økten din vil bli logget ut om{' '}
          <strong>{formatTime(secondsLeft)}</strong>.
        </DialogContentText>
        <DialogContentText sx={{ mt: 1 }}>
          Klikk knappen under for å fortsette å jobbe.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onStayLoggedIn} variant="contained" color="primary" autoFocus>
          Fortsett å jobbe
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InactivityWarningDialog;
